<template>
    <div class="actividad" v-loading="loading">
        
        <div class="actividad-acciones" v-if="activities.length">
            <el-button 
                size="small" 
                plain 
                icon="el-icon-refresh"
                @click="refresh()">Actualizar</el-button>
        </div>

        <el-timeline id="list-activity" v-if="activities.length">
            <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :timestamp="activity.timestamp">

            {{activity.content}}

            </el-timeline-item>
        </el-timeline>
        <!--<el-alert
            v-else
            title="No hay actividades"
            type="info"
            :closable="false" />-->
        <div v-else class="empty">
            <img src="../../assets/NoMessages.png">
            <p>No hay actividades</p>
            <el-button
                style="margin-top: 1rem"
                size="small" 
                type="primary"
                icon="el-icon-refresh"
                @click="refresh()">Actualizar</el-button>
        </div>
    </div>
</template>

<script>
    import {
		getActividad,
    } from '@/helpers/api'

    import moment from 'moment'
    
	export default {
        name: 'Actividad',
        props: {
            visible: {
                type: Boolean,
                default: () => false
            }
        },
        data(){
            return {
                error: null,
                loading: false,
                activities: []
            }
        },
        watch: {
            visible() {
                if (!this.visible) return
                this.getData()
            },
            activities() {
                this.scrollBottom()
            }
        },
        mounted() {
            if (this.visible) {
                this.getData()
            }
            this.$emit('created')
        },
        methods: {
            async getData(force = false) {
                
                if (this.activities && this.activities.length && !force) return

                this.loading = true

                try {

                    let resp = await getActividad()

                    this.activities = resp.data.map(m => {
                        return {
                            content: `Usuario ${m.user}: ${m.comment} - ${m.field}. ${m.old_value} a ${m.new_value}`,
                            timestamp: moment(m.datetime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
                            type: 'primary'
                        }
                    })

                } catch(e) {
                    this.error = e
                }

                this.loading = false
                
            },
            refresh() {
                this.getData(true)
            },
            scrollBottom() {
                this.$nextTick(() => {
                    var container = document.getElementById('list-activity');
                    if (!container) return
                    container.scrollTop = (parseInt(container.scrollHeight) + 200);
                })
            }
        }
	}
</script>

<style lang="scss">
.actividad {
    height: 100%;
    .actividad-acciones {
        text-align: right;
        margin-bottom: 15px;
    }
    ul#list-activity {
        height: calc(100% - 20px);
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 5px;
    }
}
</style>